import React from 'react';
import FallbackWrappedElement from '../FallbackWrappedElement/FallbackWrappedElement';
import GetNewTurn from 'Routes/Public/GetNewTurn/GetNewTurn';
import TurnList from 'Routes/Public/TurnList/TurnList';
import InvoiceReceipt from 'Routes/Protected/InvoiceReceipt/InvoiceReceipt';
import Pato from 'Routes/Protected/Pato/Pato';
import PacsImages from 'Routes/Public/PacsImages/PacsImages';
import PatientSurveyList from 'Routes/Protected/PatientSurveyList/PatientSurveyList';
import PatientCartable from 'Routes/Public/PatientCartable/PatientCartable';
import UserFeedback from 'Routes/Protected/UserFeedback/UserFeedback';
import PatientsForVisit from 'Routes/Protected/PatientsForVisit/PatientsForVisit';
import PatientsToVisitPreview from 'Routes/Protected/PatientsToVisitPreview/PatientsToVisitPreview';
import SavePatientsForVisit from 'Routes/Protected/SavePatientsForVisit/SavePatientsForVisit';
import Wallet from 'Routes/Public/Wallet/Wallet';
import NobatPrefrences from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/DrawerContent/components/NobatPrefrences/NobatPrefrences';
import WebAppSettings from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/DrawerContent/components/WebAppSettings/WebAppSettings';
import { Container, Stack } from '@mui/material';
import LanguageSelector from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/LanguageSelector/LanguageSelector';
import MoreColumSwitch from 'Global/Components/CommonComponents/MoreColumSwitch/MoreColumSwitch';
import UploadReceipt from 'Routes/Protected/UploadReceipt/UploadReceipt';

const SendFileArchive = React.lazy(() =>
  import('Routes/Public/SendFileArchive/SendFileArchive')
);
const FileArchive = React.lazy(() =>
  import('Routes/Public/FileArchive/FileArchive')
);
const AddNewConfer = React.lazy(() =>
  import('Routes/Protected/AddNewConfer/AddNewConfer')
);
const AddNewMedicalForm = React.lazy(() =>
  import(
    'Routes/Protected/AddNewMedicalForm/AddNewMedicalForm'
  )
);

const CurrentPatients = React.lazy(() =>
  import('Routes/Protected/CurrentPatients/CurrentPatients')
);
const EditConfer = React.lazy(() =>
  import('Routes/Protected/EditConfer/EditConfer')
);
const EditMedicalForm = React.lazy(() =>
  import('Routes/Protected/EditMedicalForm/EditMedicalForm')
);

const ListServiceConfer = React.lazy(() =>
  import(
    'Routes/Protected/ListServiceConfer/ListServiceConfer'
  )
);
const MainPage = React.lazy(() =>
  import('Routes/Protected/MainPage/MainPage')
);
const ServiceReportSummary = React.lazy(() =>
  import(
    'Routes/Protected/ServiceReportSummary/ServiceReportSummary'
  )
);
const Messages = React.lazy(() =>
  import('Routes/Protected/Messages/Messages')
);
const PatientList = React.lazy(() =>
  import('Routes/Protected/PatientList/PatientList')
);
const ReferTo = React.lazy(() =>
  import('Routes/Protected/ReferTo/ReferTo')
);
const SearchPatientForReferal = React.lazy(() =>
  import(
    'Routes/Protected/SearchPatientForReferal/SearchPatientForReferal'
  )
);
const TestFlight = React.lazy(() =>
  import('Routes/Protected/TestFlight/TestFlight')
);
const UploadOnCallDocs = React.lazy(() =>
  import(
    'Routes/Protected/UploadOnCallDocs/UploadOnCallDocs'
  )
);
const LabTestResult = React.lazy(() =>
  import('Routes/Protected/LabTestResult/LabTestResult')
);
const FreezeContracts = React.lazy(() =>
  import('Routes/Protected/FreezeContracts/FreezeContracts')
);
const Quartering = React.lazy(() =>
  import('Routes/Protected/Quartering/Quartering')
);
const Lab = React.lazy(() =>
  import('Routes/Protected/Lab/Lab')
);

export const NestedRoutes = (
  word,
  AccessRoles,
  isWebAppSettingsEnabled,
  rootPaths
) => {
  // console.log('wordwordwordwordword-------->', word);

  const nestedroutes = [
    //   {
    //     path: "main",
    //     component: (
    //       <FallbackWrappedElement>
    //         <MainPage />
    //       </FallbackWrappedElement>
    //     ),
    //     title: null,
    //   },

    {
      path: 'CurrentPatients',
      component: (
        <FallbackWrappedElement>
          <CurrentPatients />
        </FallbackWrappedElement>
      ),
      title: word[0],
    },
    {
      path: 'PatientList',
      component: (
        <FallbackWrappedElement>
          <PatientList />
        </FallbackWrappedElement>
      ),
      title: word[1],
    },
    //   {
    //     path: "?CompleteProfileUser",
    //     component: (
    //       <FallbackWrappedElement>
    //         <CompleteProfileUser />
    //       </FallbackWrappedElement>
    //     ),
    //     title: FindLangKey("complete-user-information-navbar-title"),
    //   },
    {
      path: 'SearchPatientForErja',
      component: (
        <FallbackWrappedElement>
          <SearchPatientForReferal />
        </FallbackWrappedElement>
      ),
      title: word[2],
    },
    //   {
    //     path: "?about",
    //     component: (
    //       <FallbackWrappedElement>
    //         <AboutUs />
    //       </FallbackWrappedElement>
    //     ),
    //     title: FindLangKey("general-public-about-us"),
    //   },
    //   {
    //     path: "?UploadOnCallDocs",
    //     component: (
    //       <FallbackWrappedElement>
    //         <UploadOnCallDocs />
    //       </FallbackWrappedElement>
    //     ),
    //     title: FindLangKey("upload-oncall-documents-navbar-title"),
    //   },
    //   {
    //     path: "?ContactUs",
    //     component: (
    //       <FallbackWrappedElement>
    //         <ContactUs />
    //       </FallbackWrappedElement>
    //     ),
    //     title: FindLangKey("general-public-contact-us"),
    //   },
    {
      path: 'ListServiceConfer',
      component: (
        <FallbackWrappedElement>
          <ListServiceConfer />
        </FallbackWrappedElement>
      ),
      title: word[3],
      patient: true,
      isGeneral: false,
    },
    //   {
    //     path: "?BankAccountList",
    //     component: (
    //       <FallbackWrappedElement>
    //         <BankAccountList />
    //       </FallbackWrappedElement>
    //     ),
    //     title: FindLangKey("bank-account-list-navbar-title"),
    //   },
    //   {
    //     path: "ChangePasswrod",
    //     component: (
    //       <FallbackWrappedElement>
    //         <ChangePasswrod />
    //       </FallbackWrappedElement>
    //     ),
    //     title: FindLangKey("general-public-change-password"),
    //   },
    {
      path: 'ServiceReportSummary',
      component: (
        <FallbackWrappedElement>
          <ServiceReportSummary />
        </FallbackWrappedElement>
      ),
      title: word[4],
    },
    {
      path: 'testFlight',
      component: (
        <FallbackWrappedElement>
          <TestFlight />
        </FallbackWrappedElement>
      ),
      title: 'Test Flight',
    },
    {
      path: 'AddNewConfer',
      component: (
        <FallbackWrappedElement>
          <AddNewConfer />
        </FallbackWrappedElement>
      ),
      title: word[5],
      patient: true,
      isGeneral: false,
    },
    {
      path: 'EditConferService',
      component: (
        <FallbackWrappedElement>
          <EditConfer />
        </FallbackWrappedElement>
      ),
      title: word[6],
      patient: true,
      isGeneral: false,
    },
    {
      path: 'AddNewElectronicForm',
      component: (
        <FallbackWrappedElement>
          <AddNewMedicalForm />
        </FallbackWrappedElement>
      ),
      title: word[7],
      patient: true,
      isGeneral: false,
    },
    //   {
    //     path: "/messages",
    //     component: (
    //       <FallbackWrappedElement>
    //         <Messages />
    //       </FallbackWrappedElement>
    //     ),
    //     title: FindLangKey("messages-navbar-title"),
    //   },
    {
      path: 'ReferTo',
      component: (
        <FallbackWrappedElement>
          <ReferTo />
        </FallbackWrappedElement>
      ),
      title: word[8],
    },
    {
      path: 'EditPatientForm',
      component: (
        <FallbackWrappedElement>
          <EditMedicalForm />
        </FallbackWrappedElement>
      ),
      title: word[9],
    },
    {
      path: 'LabTestResult',
      component: (
        <FallbackWrappedElement>
          <LabTestResult />
        </FallbackWrappedElement>
      ),
      title: word[10],
    },
    {
      path: 'FreezeContract',
      component: (
        <FallbackWrappedElement>
          <FreezeContracts />
        </FallbackWrappedElement>
      ),
      title: word[11],
    },
    {
      path: 'GetNewTurn',
      component: <GetNewTurn />,
      title: word[12],
    },
    {
      path: 'TurnList',
      component: <TurnList />,
      title: word[13],
    },
    {
      path: 'InvoiceReceipt',
      component: <InvoiceReceipt />,
      title: word[14],
    },
    {
      path: 'Quartering',
      component: (
        <FallbackWrappedElement>
          <Quartering />
        </FallbackWrappedElement>
      ),
      title: word[15],
    },
    {
      path: 'Lab',
      component: (
        <FallbackWrappedElement>
          <Lab />
        </FallbackWrappedElement>
      ),
      title: word[16],
    },
    {
      path: 'Pato',
      component: (
        <FallbackWrappedElement>
          <Pato />
        </FallbackWrappedElement>
      ),
      title: word[17],
    },
    {
      path: 'FileArchive',
      component: (
        <FallbackWrappedElement>
          <FileArchive />
        </FallbackWrappedElement>
      ),
      title: word[18],
    },
    {
      path: 'SendFileArchive',
      component: (
        <FallbackWrappedElement>
          <SendFileArchive />
        </FallbackWrappedElement>
      ),
      title: word[19],
    },
    {
      path: 'pacsImages',
      component: (
        <FallbackWrappedElement>
          <PacsImages />
        </FallbackWrappedElement>
      ),
      title: word[21],
    },
    {
      path: 'PatientSurveyList',
      component: (
        <FallbackWrappedElement>
          <PatientSurveyList />
        </FallbackWrappedElement>
      ),
      title: word[22],
    },
    {
      path: 'Cartable',
      component: (
        <FallbackWrappedElement>
          <PatientCartable />
        </FallbackWrappedElement>
      ),
      title: word[23],
    },
    {
      path: 'PatientPishNahad',
      component: (
        <FallbackWrappedElement>
          <UserFeedback />
        </FallbackWrappedElement>
      ),
      title: word[25],
    },
    {
      path: 'PatientsForVisit',
      component: (
        <FallbackWrappedElement>
          <PatientsForVisit />
        </FallbackWrappedElement>
      ),
      title: word[24],
    },
    {
      path: 'PatientsForVisitPreview',
      component: (
        <FallbackWrappedElement>
          <PatientsToVisitPreview />
        </FallbackWrappedElement>
      ),
      title: word[26],
    },
    {
      path: 'SavePatientsForVisit',
      component: (
        <FallbackWrappedElement>
          <SavePatientsForVisit />
        </FallbackWrappedElement>
      ),
      title: word[26],
    },
    {
      path: 'Wallet',
      component: (
        <FallbackWrappedElement>
          <Wallet />
        </FallbackWrappedElement>
      ),
      title: word[27],
    },
    {
      path: 'Wallet',
      component: (
        <FallbackWrappedElement>
          <Wallet />
        </FallbackWrappedElement>
      ),
      title: word[27],
    },

    ...(isWebAppSettingsEnabled &&
    AccessRoles?.includes('admin')
      ? [
          {
            path: 'NobatPrefrences',
            component: (
              <FallbackWrappedElement>
                <NobatPrefrences />
              </FallbackWrappedElement>
            ),
            title: word[28],
            noAuth: true,
          },
          {
            path: 'WebAppSettings',
            component: (
              <FallbackWrappedElement>
                <WebAppSettings />
              </FallbackWrappedElement>
            ),
            title: word[29],
            noAuth: true,
          },
        ]
      : []),

    {
      path: 'Personalization',
      component: (
        <FallbackWrappedElement>
          <Container>
            <Stack>
              <LanguageSelector />
              <MoreColumSwitch />
            </Stack>
          </Container>
        </FallbackWrappedElement>
      ),
      title: word[30],
      noAuth: true,
    },

    ...(rootPaths?.includes('/FreezeContract')
      ? [
          {
            path: 'UploadReceipt',
            component: (
              <FallbackWrappedElement>
                <UploadReceipt />
              </FallbackWrappedElement>
            ),
            title: word[31],
            noAuth: true,
          },
        ]
      : []),
  ];
  return nestedroutes;
};
